import { observer } from 'mobx-react-lite';

import useStore from '@/hooks/useStore';

const DropDown = () => {
  const { MonthlyKeywordStore } = useStore();
  const { possibleDaysData, currentDate, setCurrentDate } = MonthlyKeywordStore;

  const onChangeDropDown = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedDate = e.target.value;
    setCurrentDate(selectedDate);
  };

  if (!possibleDaysData) return null;

  return (
    <div className="keyword-select">
      <div className="keyword-select__selectbox">
        <select className="select" title="키워드 기준 제공월" onChange={onChangeDropDown} defaultValue={currentDate}>
          {possibleDaysData.map(({ dayKey, dayText }) => (
            <option key={dayKey} value={dayKey}>
              {dayText} 기준
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default observer(DropDown);
